// removed by extract-text-webpack-plugin
module.exports = {"container":"Information__container___2AvNW","information":"Information__information___7C2sJ","toggle":"Information__toggle___3Ss1r","icon":"Information__icon___1sli7"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Main/Information/Information.scss
// module id = 924
// module chunks = 0